module.exports = __webpack_public_path__ + "static/gallery3-20f109dbc90eb5905d7afa4994bd714e.jpg";